import { toast } from "react-toastify";
import * as actionTypes from "./actionTypes";
import transferenciaService from "../../api/transferenciaService";

const setLoadingTransferenciaCuentasPropiasValidar = (loading) => {
  return {
    type: actionTypes.LOADING_TRANSFERENCIA_CUENTAS_PROPIAS_VALIDAR,
    payload: { loading },
  };
};

const setLoadingTransferenciaCuentasPropiasConfirmar = (loading) => {
  return {
    type: actionTypes.LOADING_TRANSFERENCIA_CUENTAS_PROPIAS_CONFIRMAR,
    payload: { loading },
  };
};

const setLoadingTransferenciaCuentasPrymeraValidar = (loading) => {
  return {
    type: actionTypes.LOADING_TRANSFERENCIA_CUENTAS_PRYMERA_VALIDAR,
    payload: { loading },
  };
};

const setLoadingTransferenciaCuentasPrymeraConfirmar = (loading) => {
  return {
    type: actionTypes.LOADING_TRANSFERENCIA_CUENTAS_PRYMERA_CONFIRMAR,
    payload: { loading },
  };
};

const setLoadingTransferenciaCuentasIfisValidar = (loading) => {
  return {
    type: actionTypes.LOADING_TRANSFERENCIA_CUENTAS_IFIS_VALIDAR,
    payload: { loading },
  };
};

const setLoadingTransferenciaCuentasIfisConfirmar = (loading) => {
  return {
    type: actionTypes.LOADING_TRANSFERENCIA_CUENTAS_IFIS_CONFIRMAR,
    payload: { loading },
  };
};

const setLoadingBancosTransferencias = (loading) => {
  return {
    type: actionTypes.LOADING_BANCOS_TRANSFERENCIA,
    payload: { loading },
  };
};

export const setBancosTransferencias = (bancosTransferencia) => {
  return {
    type: actionTypes.LOAD_BANCOS_TRANSFERENCIA,
    payload: { bancosTransferencia },
  };
};

export const transferenciaCuentasPropiasValidar = (request) => async (
  dispatch
) => {
  dispatch(setLoadingTransferenciaCuentasPropiasValidar(true));
  try {
    const response = await transferenciaService.transferenciaCuentasPropiasValidar(
      request
    );
    dispatch(setLoadingTransferenciaCuentasPropiasValidar(false));
    return response;
  } catch (error) {
    dispatch(setLoadingTransferenciaCuentasPropiasValidar(false));
    if (error && error.data && error.data.status !== 401) {
      toast.error(error.data.message);
    }
  }
};

export const transferenciaCuentasPropiasConfirmar = (request) => async (
  dispatch
) => {
  dispatch(setLoadingTransferenciaCuentasPropiasConfirmar(true));
  try {
    const response = await transferenciaService.transferenciaCuentasPropiasConfirmar(
      request
    );
    dispatch(setLoadingTransferenciaCuentasPropiasConfirmar(false));
    return response;
  } catch (error) {
    dispatch(setLoadingTransferenciaCuentasPropiasConfirmar(false));
    if (error && error.data && error.data.status !== 401) {
      toast.error(error.data.message);
    }
  }
};

export const transferenciaCuentasPrymeraValidar = (request) => async (
  dispatch
) => {
  dispatch(setLoadingTransferenciaCuentasPrymeraValidar(true));
  try {
    const response = await transferenciaService.transferenciaCuentasPrymeraValidar(
      request
    );
    dispatch(setLoadingTransferenciaCuentasPrymeraValidar(false));
    return response;
  } catch (error) {
    dispatch(setLoadingTransferenciaCuentasPrymeraValidar(false));
    if (error && error.data && error.data.status !== 401) {
      toast.error(error.data.message);
    }
  }
};

export const transferenciaCuentasPrymeraConfirmar = (request) => async (
  dispatch
) => {
  dispatch(setLoadingTransferenciaCuentasPrymeraConfirmar(true));
  try {
    const response = await transferenciaService.transferenciaCuentasPrymeraConfirmar(
      request
    );
    dispatch(setLoadingTransferenciaCuentasPrymeraConfirmar(false));
    return response;
  } catch (error) {
    dispatch(setLoadingTransferenciaCuentasPrymeraConfirmar(false));
    if (error && error.data && error.data.status !== 401) {
      toast.error(error.data.message);
    }
  }
};

export const transferenciaCuentasIfisValidar = (request) => async (
  dispatch
) => {
  dispatch(setLoadingTransferenciaCuentasIfisValidar(true));
  try {
    const response = await transferenciaService.transferenciaCuentasIfisValidar(
      request
    );
    dispatch(setLoadingTransferenciaCuentasIfisValidar(false));
    return response;
  } catch (error) {
    dispatch(setLoadingTransferenciaCuentasIfisValidar(false));
    if (error && error.data && error.data.status !== 401) {
      toast.error(error.data.message);
    }
  }
};

export const transferenciaCuentasIfisConfirmar = (request) => async (
  dispatch
) => {
  dispatch(setLoadingTransferenciaCuentasIfisConfirmar(true));
  try {
    const response = await transferenciaService.transferenciaCuentasIfisConfirmar(
      request
    );
    dispatch(setLoadingTransferenciaCuentasIfisConfirmar(false));
    return response;
  } catch (error) {
    dispatch(setLoadingTransferenciaCuentasIfisConfirmar(false));
    if (error && error.data && error.data.status !== 401) {
      toast.error(error.data.message);
    }
  }
};

export const listarBancosTransferencia = () => async (dispatch) => {
  dispatch(setLoadingBancosTransferencias(true));
  try {
    const response = await transferenciaService.listarBancosTransferencias();

    dispatch(setBancosTransferencias(response.data.bancos));
    dispatch(setLoadingBancosTransferencias(false));
  } catch (error) {
    dispatch(setLoadingBancosTransferencias(false));
    toast.error(error);
  }
};
